import { logger } from '@heidi/runtime/logger';
import { useQuery } from '@tanstack/react-query';
import type { DocumentListResponse } from '../../../../contracts';
import { GET_USER_DOCUMENTS } from '../../../../contracts';
import { isEvidenceUserDocsEnabled, useIsAuthenticated } from '../../../injected';
import { listUserDocuments } from '../api';

interface UseUserDocumentsOptions {
  scope?: 'all' | 'user' | 'team';
  enabled?: boolean;
}

/**
 * Query hook to fetch the list of user documents
 */
export function useUserDocuments({
  scope = 'all',
  enabled = true,
}: UseUserDocumentsOptions = {}) {
  const isUserDocsEnabled = isEvidenceUserDocsEnabled();
  const isAuthenticated = useIsAuthenticated();
  return useQuery({
    queryKey: [GET_USER_DOCUMENTS, scope],
    queryFn: async (): Promise<DocumentListResponse> => {
      try {
        return await listUserDocuments(scope);
      } catch (error) {
        logger.error('Failed to fetch user documents:', error);
        return { documents: [], total: 0 };
      }
    },
    enabled: isUserDocsEnabled && enabled && isAuthenticated,
  });
}
